import { VdpParams } from './types';

export const vdpQueryKeys = {
  all: ['VDP'] as const,
  list: (params?: VdpParams) =>
    [...vdpQueryKeys.all, 'VDP_LIST', { params }] as const,
  user_list: () => [...vdpQueryKeys.all, 'USERS_WITH_VDP'] as const,
  vin_list: () => [...vdpQueryKeys.all, 'VIN_LIST'] as const,
};
